export default "__VITE_ASSET__687fc6ea__"